import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
export function OfferBlock() {
  return <section id="oferta" className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-text-light relative" data-id="element-112">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent" data-id="element-113" />

      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-800 rounded-3xl p-8 sm:p-12 border-2 border-gold-500 shadow-[0_0_40px_rgba(201,168,76,0.15)] relative overflow-hidden text-center" data-id="element-115">
          {/* Decorative glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold-500/5 blur-3xl pointer-events-none" data-id="element-116" />

          <div className="relative z-10" data-id="element-117">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-cream-50" data-id="element-118">
              No necesitas contratar una agencia de marketing de miles de
              dólares.
            </h2>
            <p className="text-xl text-cream-100/90 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-119">
              Solo necesitas cambiar lo que dices en tus chats. Obtén el sistema
              completo por menos de lo que cuesta un almuerzo fuera. Configura
              tu maquina de generar prospectos calificados, para atraerlos y
              conviertelos en clientes recurrentes que pagan por tus soluciones
              a sus problemas.
            </p>

            <div className="my-10" data-id="element-120">
              <p className="text-lg text-cream-100/60 line-through mb-2 font-[700]" data-id="element-121">
                Precio normal: $17.00 USD
              </p>
              <div className="flex flex-col items-center justify-center" data-id="element-122">
                <p className="text-xl text-gold-500 font-medium mb-1" data-id="element-123">
                  Consigue "Vender Sin Perseguir" por solo
                </p>
                <p className="text-6xl sm:text-7xl font-bold text-cream-50 tracking-tight" data-id="element-124">
                  <span className="text-gold-500 text-[48px]" data-id="element-125">$6.46 USD</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-126">
              <a href="https://aeduclub.com/cart/47773883302106:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: 'Vender Sin Perseguir',
                  content_type: 'product',
                  value: 6.46,
                  currency: 'USD'
                });
              }
            }} className="group relative inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-xl sm:text-2xl px-8 sm:px-12 py-5 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] w-full sm:w-auto overflow-hidden" data-id="element-127">
                <span className="relative z-10 flex items-center gap-2" data-id="element-128">
                  QUIERO SER UN IMÁN DE VENTAS AHORA
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-129" />
                </span>
                {/* Button shine effect */}
                <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent z-0" data-id="element-130" />
              </a>

              <div className="flex items-center gap-2 text-cream-100/70 text-sm mt-4" data-id="element-131">
                <Lock className="w-4 h-4" data-id="element-132" />
                <span data-id="element-133">Descarga instantánea. Pago 100% seguro.</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}